import {useSelector} from "react-redux";

// An admin maintains the whole archive rather than only their own uploads, so the upload
// lists and the API endpoints behind them hand back every user's rows.
const useIsAdmin = () => {
  return useSelector((state) => state.auth.roles.includes('ROLE_ADMIN'));
};

export default useIsAdmin;
